import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';

import { EyeFill, EyeSlashFill } from 'react-bootstrap-icons';

import loadable from '@loadable/component';

import { getWaterBodyByName } from '../store/reducers/fmAPI.js';

import BreadcrumbComponent from '../components/BreadcrumbComponent.js';

import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, } from 'react-router-dom';
import MapViewHeaderComponent from '../components/MapViewHeaderComponent.js';

import FloodAlertGroupSummaryComponent from '../components/FloodAlertGroupSummaryComponent.js';
import FloodAlertSummaryComponent from '../components/FloodAlertSummaryComponent.js';
import NearByStationsComponent from '../components/NearByStationsComponent.js';
import { OperationalCatchmentsLinkCalculator, SubUnitLinkCalculator } from '../lib/LinkCalculators.js';

import CentralLink from '../components/CentralLink.js';

import AdComponent from '../components/AdComponent.js';

import CommonHeaders from '../components/helmet-headers/CommonHeaders.js';
import GoverningBodyFlag from '../components/GoverningBodyFlag.js';

import TLDHelper from '../lib/tldHelper.js';

const FMCoverageAreas = loadable(() => import('../components/FMCoverageAreas.js'));
const FloodMapGeoJSONLayer =  loadable(() => import('../components/FloodMapGeoJSONLayer.js'), { ssr: false });
const StationMapMarkerLegendComponent = loadable(() => import('../components/StationMapMarkerLegendComponent.js'), { ssr: false });
const StationMapMarkerComponent = loadable(() => import('../components/StationMapMarkerComponent.js'), { ssr: false });

const MapMarkerLayerControl = loadable(() => import('../components/MapMarkerLayerControl.js'), { ssr: false });



function WaterBodyView() {
	const dispatch = useDispatch();
	const params = useParams();

	const { waterBodies } = useSelector(state => state.fmAPI);
	const { appFocusCount } = useSelector(state => state.cdvState);
	const [showSewage, setShowSewage] = useState(false);

	useEffect(() => {
		dispatch(getWaterBodyByName(params.waterBodyName));
	}, [dispatch, params.waterBodyName, appFocusCount]);

	const localFloodNavsRef = useRef(null);
	const scrollToLocalFloodNavSection = () => {
		localFloodNavsRef.current?.scrollIntoView({ behavior: 'smooth' });
	};

	let additionalCustomGeoJSON = [];

	let layerControlText;
	if(showSewage) {
		layerControlText = <span><EyeSlashFill /> Hide Sewage Stations</span>;
	} else {
		layerControlText = <span><EyeFill /> Show Sewage Stations</span>;
	}


	let floodAreaDetailButtons = [];
	if(waterBodies && waterBodies[params.waterBodyName]) {
		if(waterBodies[params.waterBodyName].floodAlertAreasLive) {
			for(let area of waterBodies[params.waterBodyName].floodAlertAreasLive) {
				if(parseInt(area.severityLevel) === 3) {
					additionalCustomGeoJSON.push(<FloodMapGeoJSONLayer.Alert key={area.floodAlertAreaId} geoJSON={area.polygon} label={"H"} />);
				}
				if(parseInt(area.severityLevel) === 2) {
					additionalCustomGeoJSON.push(<FloodMapGeoJSONLayer.Warning key={area.floodAlertAreaId} geoJSON={area.polygon} label={"H"} />);
				}

				floodAreaDetailButtons.push(<FloodAlertSummaryComponent key={area.floodAlertAreaId + "_fasc"} severityLevel={area.severityLevel} areaName={area.liveDescription} fwisCode={area.fwisCode} />)
			}
		}

		let hasFloodNavs = waterBodies[params.waterBodyName].nearByFloodNavs && waterBodies[params.waterBodyName].nearByFloodNavs.length > 0;


		let mapviewHeaderLabel = null;
		if(waterBodies && waterBodies[params.waterBodyName] && waterBodies[params.waterBodyName].waterBodyName) {
			mapviewHeaderLabel = <span><GoverningBodyFlag governingBody={waterBodies[params.waterBodyName].governingBody} padRight />{waterBodies[params.waterBodyName].waterBodyName}</span>;
		}

		return <>
			<CommonHeaders
				title={"Water Body - "+waterBodies[params.waterBodyName].waterBodyName}
				description={"View information about the '" + waterBodies[params.waterBodyName].waterBodyName + "' water body. Including stations, flood alert and warning areas, and catchment details."}
				canonicalUrlPath={"/data-explorer/water-bodies/"+waterBodies[params.waterBodyName].waterBodyName}
				canonicalDefaultWebsite={TLDHelper.mapGoverningBodyToPrimaryWebsite(waterBodies[params.waterBodyName].governingBody)}
			/>
			<Row className="screen-bottom-border">
				<Col xs={12} lg={1} xl={2} className="d-none d-lg-block large-screen-left">&nbsp;</Col>
				<Col xs={12} lg={10} xl={8}>
					<BreadcrumbComponent
						riverBasinName={waterBodies[params.waterBodyName].riverBasinName}
						subUnitName={waterBodies[params.waterBodyName].subUnitName}
						mgmtCatchmentName={waterBodies[params.waterBodyName].managementCatchmentName}
						operCatchmentName={waterBodies[params.waterBodyName].operationalCatchmentName}
						waterBodyName={null}
						leafText={waterBodies[params.waterBodyName].waterBodyName || "Unknown Water Body"}
					/>
					<MapViewHeaderComponent
						label={mapviewHeaderLabel || "Unknown Water Body"}
						geoJSON={waterBodies[params.waterBodyName].polygon}
						isStatic={false}
						overrideHeight="330px"
						
					>{/*additionalCustomGeoJSON={additionalCustomGeoJSON}*/}
						
						{waterBodies && waterBodies[params.waterBodyName] && waterBodies[params.waterBodyName].stations ? waterBodies[params.waterBodyName].stations.map(function(station) {
							if(!showSewage && station.stationPrimaryMetricType === 'Sewage Discharge') {
								return null;
							}
							return <StationMapMarkerComponent
								key={station.stationId+showSewage}
								lat={station.lat}
								lng={station.lng}
								stationName={station.stationName}
								riverName={station.riverName}
								typicalRangeHigh={station.typicalRangeHigh}
								currentHeight={station.currentHeight}
								stationId={station.stationId}
								stationPrimaryMetricType={station.stationPrimaryMetricType}
							/>;
						}) : null}
						<StationMapMarkerLegendComponent />
						<MapMarkerLayerControl key={"SS_"+showSewage} layerControlText={layerControlText} onClick={function() {
							setShowSewage((prevShowSewage) => {
						      return !prevShowSewage;
						    });
						}}/>
					</MapViewHeaderComponent>
					{hasFloodNavs && <Row>
						<Col xs={12} className="bg-secondary text-white">
							<b><i>This water body has {waterBodies[params.waterBodyName].nearByFloodNavs.length === 1 ? "a " : waterBodies[params.waterBodyName].nearByFloodNavs.length+" "}live FloodNav{waterBodies[params.waterBodyName].nearByFloodNavs.length > 1 ? "s" : ""}</i></b>{"   "}<Button size="sm" variant="dark" onClick={function() {
								scrollToLocalFloodNavSection();
							}}>View</Button>
						</Col>
					</Row>}
					<Row>
						{waterBodies[params.waterBodyName].operationalCatchmentName ? <Col xs={12} style={{paddingBottom: "10px"}}>
							This water body is part of the <strong>{waterBodies[params.waterBodyName].operationalCatchmentName}</strong> operational catchment.<br />
							<CentralLink to={OperationalCatchmentsLinkCalculator(waterBodies[params.waterBodyName].operationalCatchmentName)}><Button size="sm" variant="dark">View Catchment</Button></CentralLink>
						</Col> : null}
						{waterBodies[params.waterBodyName].subUnitName ? <Col xs={12} style={{paddingBottom: "10px"}}>
							This water body is part of the <strong>{waterBodies[params.waterBodyName].subUnitName}</strong> river sub unit.<br />
							<CentralLink to={SubUnitLinkCalculator(waterBodies[params.waterBodyName].subUnitName)}><Button size="sm" variant="dark">View Sub Unit</Button></CentralLink>
						</Col> : null}
					</Row>
					<Row>
						
					</Row>
					<Row>
						{floodAreaDetailButtons && floodAreaDetailButtons.length > 0 && <Col xs={12} className="text-white bg-dark"><b>Local Flood Warnings</b></Col>}
						<Col xs={12}>
							<FloodAlertGroupSummaryComponent floodAreas={waterBodies[params.waterBodyName].floodAlertAreasLive} noOutputIfNoAreas={true} />
						</Col>
						{floodAreaDetailButtons && floodAreaDetailButtons.length > 0 && <Col xs={12} style={{ borderTop: "1px dashed black", marginTop: "-16px"}}>
							<ListGroup style={{paddingBottom: "8px"}}>
								{floodAreaDetailButtons}
							</ListGroup>
						</Col>}
						{waterBodies[params.waterBodyName] && ((waterBodies[params.waterBodyName].floodAlertAreas || []).length+(waterBodies[params.waterBodyName].floodAlertAreasLive || []).length) && floodAreaDetailButtons && floodAreaDetailButtons.length === 0 ? <ListGroup style={{paddingBottom: "8px"}}>
							<ListGroup.Item><i>No current flood warnings for this location</i></ListGroup.Item>
						</ListGroup> : <><hr /><span><b>FloodMapper</b> does not track any alert or warning areas for flooding in this water body.</span><hr /></>}
					</Row>
					{hasFloodNavs && <div ref={localFloodNavsRef}>
						<Row>
							<Col xs={12} className="text-white bg-dark"><b>Local FloodNavs</b></Col>
							<Col xs={12}>
								<i>This water body has <strong>{waterBodies[params.waterBodyName].nearByFloodNavs.length}</strong> associated <strong>Live FloodNav{waterBodies[params.waterBodyName].nearByFloodNavs.length > 1 && "s"}</strong></i>
							</Col>
							<Col xs={12}>
								<FMCoverageAreas fmCoverageAreas={waterBodies[params.waterBodyName].nearByFloodNavs} enableHeader={false} />
							</Col>
						</Row>
					</div>}
					{(process.env.REACT_APP_ENABLE_GOOGLE_ADS === "true" && process.env.REACT_APP_ENABLE_GOOGLE_ADS_ON_WATERBODIES === "true") && <Row style={{marginTop: "17px"}}>
						<Col xs={12}>
							<AdComponent
							  client="ca-pub-6790224688210339"
							  slot="6130981811"
							  format="fluid"
							  layoutKey="-fb+5w+4e-db+86"
							  responsive={true}
							/>
						</Col>
					</Row>}
					{((waterBodies[params.waterBodyName].floodAlertAreas && waterBodies[params.waterBodyName].floodAlertAreas.length > 0) || (waterBodies[params.waterBodyName].stations && waterBodies[params.waterBodyName].stations.length > 0)) && <Row>
						<Col xs={12} className="text-white bg-dark">
							<b>Local Information</b>
						</Col>
					</Row>}
					<Row>
						{waterBodies[params.waterBodyName].stations && waterBodies[params.waterBodyName].stations.length > 0 && <Col xs={12} sm={6} md={4} xlg={3}>
							<NearByStationsComponent headingText="Water Level Stations" stations={waterBodies[params.waterBodyName].stations} />
							<NearByStationsComponent stations={waterBodies[params.waterBodyName].stations} headingText="Sewage Stations" overrideIncludeTypes={["Sewage Discharge"]} />
						</Col>}
						{waterBodies[params.waterBodyName].stations && waterBodies[params.waterBodyName].stations.length === 0 && <ListGroup style={{paddingBottom: "8px"}}>
							<ListGroup.Item><i>No measurement stations for this water body</i></ListGroup.Item>
						</ListGroup>}
						{waterBodies[params.waterBodyName].floodAlertAreas && waterBodies[params.waterBodyName].floodAlertAreas.length > 0 && <Col xs={12} sm={6} md={4} xlg={3}>
							<ListGroup>
								<ListGroup.Item variant="dark" className="bg-dark text-white">
								Alert Areas
								</ListGroup.Item>
								<div>
									{waterBodies[params.waterBodyName].floodAlertAreas && waterBodies[params.waterBodyName].floodAlertAreas.map(function(fa) {
										return <ListGroup.Item>
											<FloodAlertSummaryComponent key={fa.fwisCode} severityLevel={"4"} areaName={fa.floodAlertAreaName} fwisCode={fa.fwisCode} />
										</ListGroup.Item>
									})}
									{(!waterBodies[params.waterBodyName].floodAlertAreas || waterBodies[params.waterBodyName].floodAlertAreas.length === 0) && <ListGroup.Item><i><b>None</b></i></ListGroup.Item>}
								</div>
							</ListGroup>
						</Col>}
					</Row>
				</Col>
				<Col xs={12} lg={1} xl={2} className="d-none d-lg-block large-screen-right">&nbsp;</Col>
			</Row>
		</>;
	} else {
		return 'Loading...';
	}

	
}

export default WaterBodyView;